import { dispatch, req } from "hf-rt";
// import { HOST_URL } from "../constants";

const initialState = {
  inStoreInfo: null,
  getInStoreInfoSuccessfully: false,
  toggleReservationPopup: false
};

export default {
  name: "pickUpInStore",
  actions: {
    updateInStore: payload => dispatch({ type: "UPDATE_INSTORE", payload }),
    fetchInStore: async function () {
      dispatch({ type: "FETCH_INSTORE" });
      const data = await req.get({
        api: "pickUpInStore"
      });
      this.updateInStore(data);
    },
    setToggleReservationPopup: function (bool) {
      dispatch({ type: "SET_TOGGLE_RESERVATION_POPUP", bool });
    }
  },
  reducers: function (state = initialState, action) {
    switch (action.type) {
      case "UPDATE_INSTORE":
        return {
          ...state,
          getInStoreInfoSuccessfully: true,
          inStoreInfo: action.payload
        };
      case "SET_TOGGLE_RESERVATION_POPUP":
        return {
          ...state,
          toggleReservationPopup: action.bool
        };
      default:
        return state;
    }
  }
};
